<template>
  <div v-loading.body="loading">
    <div class="c_page-title">
      <div>坏账审核列表-仓库</div>
      <el-button
        class="icon-fresh"
        size="mini"
        icon="el-icon-refresh"
        @click="fetchData(true)"
        >刷新</el-button
      >
    </div>
    <el-row class="filter">
      <el-col>
        <div
          style="
            background: #f3f3f3;
            height: 30px;
            line-height: 30px;
            padding: 0 25px;
            display: flex;
            align-items: center;
          "
        >
          <div>查询搜索</div>
          <el-button
            type="text"
            style="margin-left: auto"
            :icon="filterFold ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"
            @click="toggleFilter"
            >{{ filterFold ? "展开筛选" : "收起筛选" }}</el-button
          >
        </div>
        <el-collapse-transition>
          <div v-show="!filterFold">
            <div style="padding: 10px 25px">
              <el-form :inline="true" :model="form" class="demo-form-inline">
                <div style="display: flex; flex-direction: row">
                  <div
                    style="
                      width: 180px;
                      line-height: 40px;
                      font-size: 14px;
                      color: #606266;
                    "
                  >
                    搜索条件:
                  </div>
                  <div>
                    <el-form-item label="">
                      <el-input
                        v-model="form.goods_no"
                        placeholder="商品货号"
                        @keyup.native.enter="search"
                      ></el-input>
                    </el-form-item>
                    <el-form-item label="">
                      <el-input
                        v-model="form.goods_name"
                        placeholder="商品名称"
                        @keyup.native.enter="search"
                      ></el-input>
                    </el-form-item>
                    <el-form-item label="">
                      <el-input
                        v-model="form.market_name"
                        placeholder="市场"
                        @keyup.native.enter="search"
                      ></el-input>
                    </el-form-item>
                    <el-form-item label="">
                      <el-input
                        v-model="form.supply_name"
                        placeholder="商家"
                        @keyup.native.enter="search"
                      ></el-input>
                    </el-form-item>
                    <el-form-item>
                      <el-select
                        v-model="form.city"
                        multiple
                        placeholder="请选择商家城市"
                      >
                        <el-option
                          v-for="item in citys"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item label="">
                      <el-input
                        v-model="form.woid"
                        placeholder="代采单"
                        @keyup.native.enter="search"
                      ></el-input>
                    </el-form-item>
                    <el-form-item label="">
                      <el-select v-model="form.pgid" placeholder="代采组">
                        <el-option :key="0" value="0" label="全部"></el-option>
                        <el-option
                          v-for="item in resData.pgOption"
                          :key="item.value"
                          :value="item.value"
                          :label="item.label"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item label="">
                      <el-select
                        v-model="form.order_owner"
                        filterable
                        placeholder="订单负责人"
                      >
                        <el-option :key="0" value="0" label="全部"></el-option>
                        <el-option
                          v-for="item in resData.owner_option"
                          :key="item.value"
                          :value="item.value"
                          :label="item.label"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item label="">
                      <el-input
                        v-model="form.application_name"
                        placeholder="申请人"
                        @keyup.native.enter="search"
                      ></el-input>
                    </el-form-item>
                    <el-form-item label="">
                      <el-input
                        v-model="form.audit_name"
                        placeholder="审核人"
                        @keyup.native.enter="search"
                      ></el-input>
                    </el-form-item>
                    <el-form-item label="">
                      <el-input
                        v-model="form.sku"
                        placeholder="sku"
                        @keyup.native.enter="search"
                      ></el-input>
                    </el-form-item>
                    <el-form-item label="">
                      <el-select v-model="form.source" placeholder="欠货来源">
                        <el-option :key="0" value="0" label="全部"></el-option>
                        <el-option
                          v-for="item in resData.source_option"
                          :key="item.value"
                          :value="item.value"
                          :label="item.label"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item>
                      <el-input v-model="form.id" placeholder="坏账单ID">
                      </el-input>
                    </el-form-item>
                    <el-form-item label="">
                      <el-select
                        v-model="form.p_reason_id"
                        placeholder="一级原因"
                        @change="setReson"
                      >
                        <el-option
                          :key="0"
                          :value="'0'"
                          label="全部"
                        ></el-option>
                        <el-option
                          v-for="item in resData.reasonOption"
                          :key="item.reason_id"
                          :label="item.reason_name"
                          :value="item.reason_id"
                        >
                        </el-option>
                      </el-select>
                      <el-select
                        v-model="form.reason_id"
                        placeholder="二级原因"
                      >
                        <el-option
                          :key="0"
                          :value="'0'"
                          label="全部"
                        ></el-option>
                        <el-option
                          v-for="item in subReasonOption"
                          :key="item.reason_id"
                          :label="item.reason_name"
                          :value="item.reason_id"
                        >
                        </el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item label="">
                      <el-select v-model="form.status" placeholder="请选择">
                        <el-option
                          v-for="item in statusOption"
                          :key="item.status"
                          :label="item.status_value"
                          :value="item.status"
                        >
                        </el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item>
                      <el-select
                        v-model="form.dgid"
                        filterable
                        placeholder="次品组"
                      >
                        <el-option label="全部" value=""></el-option>
                        <el-option
                          v-for="item in resData.dg_group"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item>
                      <el-select
                        v-model="form.dpc_id"
                        filterable
                        placeholder="退换货负责人"
                      >
                        <el-option label="全部" value=""></el-option>
                        <el-option
                          v-for="item in resData.option_dgm"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        ></el-option>
                      </el-select>
                    </el-form-item>

                    <el-form-item>
                      <el-select
                        v-model="form.cg_type"
                        placeholder="代采单类型"
                      >
                        <el-option label="全部" value=""></el-option>
                        <el-option
                          v-for="item in resData.cg_type_option"
                          :key="item.key"
                          :label="item.label"
                          :value="item.key"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item>
                      <el-select
                        v-model="form.has_other_woid"
                        placeholder="是否关联盘盈代采单号"
                        clearable
                      >
                        <el-option label="是" value="1"></el-option>
                        <el-option label="否" value="0"></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item>
                      <el-select
                        v-model="form.owe_label"
                        placeholder="代采欠货标签"
                      >
                        <el-option label="全部" value="0"></el-option>
                        <el-option
                          v-for="item in oweLabelOptions"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item>
                      <el-input
                        v-model="form.stock_out_create_admin_str"
                        placeholder="扫码出库人"
                        @keyup.native.enter="search"
                      ></el-input>
                    </el-form-item>
                  </div>
                </div>
                <el-form-item label="订单生成时间：">
                  <el-date-picker
                    v-model="form.wo_create_time"
                    type="daterange"
                    value-format="yyyy-MM-dd"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                  >
                  </el-date-picker>
                </el-form-item>
                <el-form-item label="申请时间：">
                  <el-date-picker
                    v-model="form.application_time"
                    type="daterange"
                    value-format="yyyy-MM-dd"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                  >
                  </el-date-picker>
                </el-form-item>
                <el-form-item label="审核时间：">
                  <el-date-picker
                    v-model="form.auditor_time"
                    type="daterange"
                    value-format="yyyy-MM-dd"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                  >
                  </el-date-picker>
                </el-form-item>
                <el-form-item label="退换货生成时间">
                  <el-date-picker
                    v-model="form.stock_out_create_time"
                    type="daterange"
                    value-format="yyyy-MM-dd"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                  >
                  </el-date-picker>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="search">查询</el-button>
                </el-form-item>
              </el-form>
            </div>
          </div>
        </el-collapse-transition>
      </el-col>
    </el-row>
    <el-row>
      <el-col style="border: 1px solid #ddd">
        <div
          style="
            background: #f3f3f3;
            height: 50px;
            line-height: 30px;
            padding: 0 25px;
            display: flex;
            align-items: center;
          "
        >
          <el-button
            style="margin-left: auto"
            type="warning"
            size="small"
            @click="brokenDebtAudit(0)"
            >通过</el-button
          >
          <el-button type="danger" size="small" @click="brokenDebtAudit(1)">
            驳回</el-button
          >
          <el-button type="success" size="small" @click="output">
            导出</el-button
          >
        </div>
        <div style="margin-bottom: 0">
          <el-table
            v-if="resData"
            ref="multipleTable"
            v-loading="tableLoading"
            height="600"
            :data="resData.list"
            tooltip-effect="dark"
            style="width: 100%"
            :cell-class-name="addColor"
            @selection-change="handleSelectionChange"
          >
            <el-table-column type="selection" label="选择"></el-table-column>
            <el-table-column prop="id" label="坏账单ID" align="center">
            </el-table-column>
            <el-table-column
              prop="goods_img"
              label="图片"
              show-overflow-tooltip
              align="center"
            >
              <template slot-scope="scope">
                <div
                  v-viewer
                  style="
                    width: 40px;
                    height: 40px;
                    overflow: hidden;
                    cursor: pointer;
                    margin: auto;
                  "
                >
                  <img
                    :src="scope.row.main_img"
                    alt=""
                    style="width: 100%; height: 100%"
                  />
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="brand_name"
              label="品牌"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="goods_name"
              label="商品名称"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="goods_no"
              label="货号"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="woid"
              label="代采单"
            ></el-table-column>
            <el-table-column
              prop="wcg_order_cg_type_text"
              align="center"
              label="代采单类型"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="wo_create_time"
              label="代采单生成时间"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="source"
              label="欠货来源"
            ></el-table-column>
            <el-table-column
              align="right"
              prop="market_name"
              label="商家当前市场"
              width="55"
            ></el-table-column>
            <el-table-column
              prop="supply_name"
              label="商家"
              align="center"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="pgname"
              label="代采组"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="order_owner_name"
              label="订单负责人"
            ></el-table-column>
            <el-table-column
              prop="dg_group_name"
              filterable
              label="次品组"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="dgm_name"
              filterable
              label="退换货负责人"
              show-overflow-tooltip
              align="center"
            ></el-table-column>

            <el-table-column
              prop="co_val"
              label="颜色"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="si_val"
              label="尺码"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="sku"
              label="sku"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="price"
              label="代采单价"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="first_reson"
              label="一级原因"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="second_reson"
              label="二级原因"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop=""
              label="坏账凭证"
              show-overflow-tooltip
              align="center"
            >
              <template slot-scope="scope">
                <div
                  v-viewer
                  style="
                    width: 40px;
                    height: 40px;
                    overflow: hidden;
                    cursor: pointer;
                    margin: auto;
                  "
                >
                  <img
                    v-for="(item, key) in scope.row.docs"
                    :key="key"
                    :src="item"
                    style="max-width: 100%; max-height: 100%"
                  />
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="other_price"
              label="替代商品代采价"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="avg_price"
              label="替代商品平均代采价"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="surplus_price"
              label="坏账差额"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="reason"
              label="换货差额原因"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="remark"
              label="备注"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="application_name"
              label="申请人"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="application_time"
              label="申请时间"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="broken_debts_record_status"
              label="状态"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="audit_name"
              label="审核人"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="auditor_remark"
              label="审核备注"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="update_time"
              label="审核时间"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="stock_out_create_admin_str"
              label="扫码出库人"
              show-overflow-tooltip
              align="center"
              width="90"
            >
            </el-table-column>
            <el-table-column
              prop="stock_out_create_time"
              label="退换货生成时间"
              show-overflow-tooltip
              align="center"
              width="150"
            >
            </el-table-column>
          </el-table>
        </div>
        <div v-if="resData" style="text-align: right; padding: 25px">
          <el-pagination
            :current-page.sync="curPage"
            background
            layout="total, prev, pager, next, sizes, jumper"
            :total="resData.count"
            :page-size="form.page_size"
            :page-sizes="[50, 100, 200, 500, 1000]"
            @current-change="handleCurrentChange"
            @size-change="
              (v) => {
                form.page_size = v;
                fetchData();
              }
            "
          >
          </el-pagination>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import apiBaseURL from "@/utils/baseUrl.js";
import { CITY } from "@/const/CommonConst.js";

export default {
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.fetchData();
    });
  },
  data() {
    return {
      condition: 1,
      resData: {
        pgOption: [],
        reasonOption: [],
        list: [],
        count: 0,
      },
      ids: [],
      subReasonOption: [],
      supply: {
        list: [],
      },
      form: {
        reason_id: "0",
        p_reason_id: "0",
        wo_create_time: [],
        page_size: 100,
        application_time: this.defaultDate(),
        city: [],
        owe_label: "",
        has_other_woid: "",
      },
      loading: false,
      tableLoading: false,
      url: "/erp/BrokenDebts/getCkBrokenDebts",
      curPage: 1,
      filterFold: false,
      isAll: false,
      supplyData: null,
      citys: CITY,
      statusOption: [
        { status: "0", status_value: "全部" },
        { status: "2", status_value: "代采终审待审核" },
        { status: "5", status_value: "代采终审驳回" },
      ],
      oweLabelOptions: [
        {
          label: "订单欠货",
          value: "1",
        },
        {
          label: "在途库存",
          value: "2",
        },
      ],
    };
  },
  computed: {
    filteredForm() {
      const { form } = this;
      Object.keys(form).forEach((key) => {
        if (form[key] === undefined || form[key] === "" || form[key] === null) {
          delete form[key];
        }
      });
      return form;
    },
  },
  methods: {
    defaultDate() {
      const endDate = new Date();
      const endM =
        endDate.getMonth() + 1 < 10
          ? `0${endDate.getMonth() + 1}`
          : endDate.getMonth() + 1;
      const end = `${endDate.getFullYear()}-${endM}-${endDate.getDate()}`;

      const startDate = new Date();
      startDate.setDate(startDate.getDate() - 30);
      const startM =
        startDate.getMonth() + 1 < 10
          ? `0${startDate.getMonth() + 1}`
          : startDate.getMonth() + 1;
      const start = `${startDate.getFullYear()}-${startM}-${startDate.getDate()}`;
      return [start, end];
    },
    // 坏账分类
    setReson(reasonId) {
      this.subReasonOption = [];
      this.form.reason_id = "0";

      Object.keys(this.resData.reasonOption).forEach((key) => {
        const item = this.resData.reasonOption[key];
        if (item.reason_id === reasonId) {
          this.subReasonOption = item.children;
        }
      });
    },
    brokenDebtAudit(status) {
      if (this.ids.length < 1) {
        this.$alert("没有选中项目", "操作错误", {
          confirmButtonText: "确定",
          center: true,
        });
        return;
      }
      let text = "确定通过转坏账申请？";
      if (status === 1) text = "确定驳回转坏账申请？";
      this.$confirm("", text, {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        showInput: status === 1,
        center: true,
      })
        .then((e) => {
          let remark = "";
          if (status === 1) {
            remark = e.value !== undefined ? e.value : "";
          }
          this.$http
            .post("/erp/BrokenDebts/checkBrokenDebts", {
              type: status,
              ids: this.ids,
              remark,
            })
            .then((res) => {
              if (res.data.code !== 200) {
                this.$message.error(res.data.msg);
                return;
              }
              this.$message.success("操作成功");
              this.fetchData();
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "取消操作!",
          });
        });
    },
    addColor({ columnIndex }) {
      if (columnIndex === 15) {
        return "blue-cell";
      }
      return "";
    },
    output() {
      this.$http
        .post(this.url, { ...this.filteredForm, is_excel: 1 })
        .then((res) => {
          if (res.data.code !== 200) {
            this.$message.error(res.data.msg);
          } else {
            window.open(apiBaseURL + res.data.data.file);
          }
        });
    },
    fetchData(showLoading) {
      if (showLoading) {
        this.loading = true;
      }
      this.form.condition = this.condition;

      this.$http.post(this.url, this.filteredForm).then((res) => {
        this.loading = false;
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
          return;
        }
        this.resData = res.data.data;
      });
    },
    toggleFilter() {
      this.filterFold = !this.filterFold;
    },
    handleSelectionChange(val) {
      this.ids = [];
      val.forEach((item) => {
        this.ids.push(item.id);
      });
    },
    // 切换页码
    handleCurrentChange(val) {
      this.form.page = val;
      this.tableLoading = true;
      this.$http.post(this.url, this.filteredForm).then((res) => {
        setTimeout(() => {
          this.tableLoading = false;
        }, 200);
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
        }
      });
    },
    search() {
      this.condition = 0;
      this.fetchData();
    },
  },
};
</script>

<style scoped>
.row {
  height: 60px;
}

.column {
  text-align: center;
  border: 1px solid #ddd;
  font-size: 12px;
}

.data-statics {
  background: #f3f3f3;
  height: 40px;
  font-size: 14px;
  color: #333;
  line-height: 40px;
  padding: 0 25px;
}

.filter {
  border: 1px solid #ddd;
}

.el-row {
  margin-bottom: 20px;
}

.el-row:last-child {
  margin-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/PurchaseCkBrokenDebts.vue